/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MinSideAccessControl {
    AccessRequestsView = 'AccessRequestsView',
    AccessRequestsEdit = 'AccessRequestsEdit',
    EndUserCreate = 'EndUserCreate'
}


export function instanceOfMinSideAccessControl(value: any): boolean {
    for (const key in MinSideAccessControl) {
        if (Object.prototype.hasOwnProperty.call(MinSideAccessControl, key)) {
            if (MinSideAccessControl[key as keyof typeof MinSideAccessControl] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MinSideAccessControlFromJSON(json: any): MinSideAccessControl {
    return MinSideAccessControlFromJSONTyped(json, false);
}

export function MinSideAccessControlFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinSideAccessControl {
    return json as MinSideAccessControl;
}

export function MinSideAccessControlToJSON(value?: MinSideAccessControl | null): any {
    return value as any;
}

export function MinSideAccessControlToJSONTyped(value: any, ignoreDiscriminator: boolean): MinSideAccessControl {
    return value as MinSideAccessControl;
}

